import apiClient from "./apiClient";

export const getAllCountries = () => apiClient.get(null, 'public/countries')